const List = require('./../../models/list').default;


const { baseTimeFields, createdTimeField } = require('@/classes/timeFields');

module.exports = {
    routes: [{
        path: '/lists',
        name: 'lists',
        meta: {
            permissions: ['lists.read']
        },
        component: () => import('./views/index.vue')
    },
    {
        path: '/lists/detail/:id?',
        name: 'list',
        meta: {
            permissions: ['lists.update', 'lists.create']
        },
        component: () => import('./views/detail.vue')
    },],
    search: [{
        'icon': 'mdi-format-text',
        'label': 'Naam',
        'type': 'property',
        'settings': {
            'fields': ['name'],
            'title': '{name}',
        },
        'filter': 'name'
    },
    ],
    itemObject: List,
    detail: {
        route: 'list',
        endpoint: 'list',
        objectName: 'List',
        saveOptions: {
            create: {
                returnfields: ['id', 'listItems{id name description isDeleted isActive low high color stepSize threshold fields{name isActive translations{locale value isActive}}}']
            },
            update: {
                returnfields: ['id', 'listItems{id name description isDeleted isActive low high color stepSize threshold fields{name isActive translations{locale value isActive}}}']
            }
        },
        fields: ['id', 'name', 'description', 'listItems{id name description isDeleted isActive low high color stepSize threshold fields{name isActive translations{locale value isActive}}}', 'isActive', 'isSystem', 'itemType', 'fields{name isActive}'],
        tabs: [
            {
                tab: 'general',
                text: 'Algemeen'
            }, {
                tab: 'fields',
                text: 'Velden',
            }
        ]
    },
    index: {
        defaultTimeField: 'createdAt',
        timeFields: baseTimeFields,
        route: 'lists',
        endpoint: 'lists',
        fields: ['id', 'name', 'description', 'listItems{id}', 'createdAt', 'updatedAt', 'isActive'],
        headers: [
            {
                text: 'Naam',
                value: 'name',
                component: () => import('./../../components/columns/eod-column-link.vue')
            },
            {
                text: 'Items',
                value: item => {
                    if (!item.listItems) {
                        return 0;
                    }
                    return item.listItems.length;
                },
                width: 50,
                component: () => import('./../../components/columns/eod-column-link.vue')
            },
            {
                text: 'Aanmaakdatum',
                width: 50,
                value: 'createdAt',
                component: () => import('./../../components/columns/eod-column-date.vue'),
                extra: {
                    icon: 'mdi-alarm-plus',
                    collapsed: true,
                    prepend: 'Aangemaakt op'
                }
            }, {
                text: 'Aanpassingsdatum',
                width: 50,
                value: 'updatedAt',
                component: () => import('./../../components/columns/eod-column-date.vue'),
                extra: {
                    icon: 'mdi-alarm',
                    collapsed: true,
                    prepend: 'Gewijzigd op'
                }
            },
            {
                width: 80,
                sortable: false,
                value: 'isActive',
                component: () => import('./columns/switch.vue')
            },
            {
                width: 60,
                sortable: false,
                value: 'actions',
                draggable: false,
                component: () => import('./../../components/columns/eod-column-actions.vue')
            }
        ],
        tabs: [{
            path: 'lists',
            text: 'Overzicht'
        }],
    }
}